import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgResendInvoice = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.295 6.956a.4.4 0 0 1-.4.4h-3.333a.4.4 0 0 1 0-.8h2.323l-1.842-1.731-.009-.009a4.6 4.6 0 0 0-7.59 1.717.4.4 0 0 1-.754-.266 5.4 5.4 0 0 1 8.905-2.021l1.9 1.785V3.622a.4.4 0 0 1 .8 0v3.334ZM1.489 9.112a.399.399 0 0 1 .4-.4h3.334a.4.4 0 1 1 0 .8H2.899l1.842 1.731.009.009a4.6 4.6 0 0 0 7.59-1.717.4.4 0 1 1 .754.266 5.4 5.4 0 0 1-8.905 2.02l-1.9-1.784v2.409a.4.4 0 1 1-.8 0V9.112Z",
    fill: "#511E62"
  })
}));
export default SvgResendInvoice;